import React from "react";
import { Route, Switch } from "react-router-dom";

import { requireOfferSign } from "~/require-offer-sign";

import { AgreementPage } from "./agreement-page";
import { DocumentsLayout } from "./documents-layout";
import { DocumentsPage } from "./documents-page";
import { OfferPage } from "./offer-page";

function DocumentsRoutes() {
  return (
    <DocumentsLayout>
      <Switch>
        <Route path="/pages/documents/offer" component={OfferPage} />
        <Route path="/pages/documents/:doctor_agreement_id" component={AgreementPage} />
        <Route path="/pages/documents" component={DocumentsPage} />
      </Switch>
    </DocumentsLayout>
  );
}

export default requireOfferSign(DocumentsRoutes);
